import { TableRow } from '@mui/material';
import { StyledTableCell } from '../../../shared/components/CustomTable/Styled';
import { Kpi } from '../../../data/entities';
import { StyledNavLink } from '../../../shared/styled/TableStyles';
import ProgressBar from '../../../shared/components/ProgressBar';
import { color } from '../../../shared/styles';
import { formatCurrency } from '../../../utils/format';
import { KPI_STATUS } from '../../../data/enums';

interface KpiCustomTable {
    item: Kpi;
}

export const KpiRevenueCustomTable = ({ item }: KpiCustomTable) => {
    const type = item.type;
    const year = item.type === 'Revenue' ? item.duration : '';
    const name = item.type === 'Revenue' ? item.name : '';
    const currentValue = item.type === 'Revenue' ? item.current_value : '';
    const targetValue = item.type === 'Revenue' ? item.target_value : '';
    const status = item.type === 'Revenue' ? item.status : '';

    const statusMap: Record<string, string> = {
        [KPI_STATUS.OPEN]: 'Mở',
        [KPI_STATUS.ONGOING]: 'Đang tiến hành',
        [KPI_STATUS.ACHIEVED]: 'Đạt',
        [KPI_STATUS.FAILED]: 'Không đạt',
    };

    return (
        <>
            {type === 'Revenue' && (
                <TableRow>
                    <StyledTableCell align="left">
                        <>
                            {item.duration_unit === 'YEAR' && (
                                <StyledNavLink to={`/kpis/${item.id}`}>
                                    {year}
                                </StyledNavLink>
                            )}
                        </>
                    </StyledTableCell>
                    <StyledTableCell align="left">{name}</StyledTableCell>
                    <StyledTableCell align="left">
                        {formatCurrency(Number(targetValue))}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                        {formatCurrency(Number(currentValue))}
                    </StyledTableCell>
                    <StyledTableCell align="left">{statusMap[status]}</StyledTableCell>
                </TableRow>
            )}
        </>
    );
};

export const KpiCategoryTable = ({ item }: KpiCustomTable) => {
    const type = item.type;
    const year = item.type === 'Category' ? item.duration : '';
    const name = item.name;
    const subtype = item.type === 'Category' ? item.subtype : '';
    const currentValue = item.type === 'Category' ? item.current_value : 0;
    const targetValue = item.type === 'Category' ? item.target_value : 0;
    const status = item.type === 'Category' ? item.status : '';
    const progressValue = targetValue ? (currentValue / targetValue) * 100 : 0;
    const progressColor =
        item.subtype === 'Phuy'
            ? color.status.WARNING
            : item.subtype === 'Thùng'
              ? color.status.INFORMATION
              : color.status.SUCCESS;

    return (
        <>
            {type === 'Category' && (
                <TableRow>
                    <StyledTableCell align="left">
                        <>
                            {item.duration_unit === 'YEAR' && (
                                <StyledNavLink to={`/kpis/${item.id}`}>
                                    {year}
                                </StyledNavLink>
                            )}
                        </>
                    </StyledTableCell>
                    <StyledTableCell align="left">{name}</StyledTableCell>
                    <StyledTableCell align="left">{subtype}</StyledTableCell>
                    <StyledTableCell align="left">
                        {targetValue}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                        {currentValue}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                        <ProgressBar
                            value={progressValue}
                            fillColor={progressColor}
                        />
                    </StyledTableCell>
                    <StyledTableCell align="left">{status}</StyledTableCell>
                </TableRow>
            )}
        </>
    );
};
